import router from './router'
// import { getToken } from '@/utils/auth' // 验权
import { getUrlParam } from "@/utils/param";
import store from '@/store'
const whiteList = ['/rescue']


// 根据路由设置标题
router.beforeEach((to, from, next) => {
  let code = getUrlParam("code");
  if (code) {
    let state = getUrlParam("state");
    store.dispatch("Login", { code, state }).then(() => {
    });
    next()
  } else {
    // if (to.meta.title) {
    //   document.title = to.meta.title
    // }
    next();
  }
})

router.afterEach((to, from) => {

})



// WEBPACK FOOTER //
// ./src/permission.js